import Filter from "assets/svgs/filter/Filter";
import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useReps } from "./store";
import { isEmpty } from "lodash";
import { Badge, Button, Form, Select, Space } from "antd";
import moment from "moment";
import DatePicker from "react-datepicker";

import {
  categoryOptions,
  feedOptions,
  genderOptions,
  optionsCaseStatus,
  optionsFormStatus,
  slotOptions,
} from "constants/options";
import { getCurrentUserRole, getQueryParams, levelOptions } from "modules/utilities/utility";
import { useNavigate } from "react-router-dom";
const { Option } = Select;

function CaseFilter({ setQuery, page, setPage }) {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { consultReps, salesReps, medReps } = useReps();
  const [show, setShow] = useState(false);
  const [assignedTo, setAssignedTo] = useState(getQueryParams("assignedTo"));
  const [startDate, setStartDate] = useState(getQueryParams("startDate"));
  const [endDate, setEndDate] = useState(getQueryParams("endDate"));
  const [caseStatus, setCaseStatus] = useState(getQueryParams("caseStatus"));
  const [feedback, setFeedback] = useState(getQueryParams("feedback"));
  const [formStatus, setFormStatus] = useState(getQueryParams("formStatus"));
  const [repLevel, setRepLevel] = useState(getQueryParams("repLevel"));
  const [category, setCategory] = useState(getQueryParams("category"));
  const [gender, setGender] = useState(getQueryParams("gender"));
  const [slot, setSlot] = useState(getQueryParams("slot"));

  useEffect(() => {
    form.setFieldsValue({
      startDate: startDate ? moment(startDate) : moment(),
      endDate: endDate ? moment(endDate) : null,
      caseStatus: caseStatus,
      feedback: feedback,
      formStatus: formStatus,
      assignedTo: assignedTo,
      repLevel: repLevel,
      category: category,
      slot: slot,
      gender: gender,
    });
  }, [
    assignedTo,
    endDate,
    caseStatus,
    feedback,
    formStatus,
    assignedTo,
    repLevel,
    category,
    slot,
    gender,
  ]);
  const isFormEmpty = (values) => {
    return Object.values(values).every((value) => !value);
  };

  const generateQuery = (items) => {
    const query = new URLSearchParams(window.location.search);
    items.map((item) => {
      Object.entries(item).map(([key, value]) => {
        if (value)
          return query.has(key)
            ? query.set(key, value)
            : query.append(key, value);
        else return query.delete(key);
      });
      return query;
    });
    return query.toString();
  };

  const onSubmit = async (items) => {
    setPage(1);
    const filterItems = [];

    Object.entries(items).map(([key, value]) => {
      if (
        key === "startDate" &&
        window.location.pathname !== "case-management/all-cases"
      ) {
        filterItems.push({
          [key]: startDate ? moment(startDate).format("YYYY-MM-DD") : undefined,
        });
      } else if (key === "endDate") {
        filterItems.push({
          [key]: endDate ? moment(endDate).format("YYYY-MM-DD") : undefined,
        });
      } else {
        filterItems.push({ [key]: value });
      }
      filterItems.push({ pageNumber: 1 });
      return [...new Set(filterItems)];
    });
    const queryParams = generateQuery(filterItems);
    queryParams.includes("startDate")
      ? setQuery(`&${queryParams}`)
      : setQuery(
          `?startDate=${moment(new Date()).format("YYYY-MM-DD")}&${queryParams}`
        );
    navigate(`${window.location.pathname}?&${queryParams}`);
    handleClose();
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [currPathName, setCurrentPathName] = useState(window.location.href);
  const [userRole] = useState(getCurrentUserRole());

  useEffect(() => {
    setCurrentPathName(window.location.href);
  }, [window.location.pathname]);

  useEffect(() => {
    handleClear();
  }, [window.location.pathname]);

  const handleClear = () => {
    form.resetFields();
    setCaseStatus(null);
    setFeedback(null);
    setFormStatus(null);
    setStartDate(moment().format("YYYY-MM-DD"));
    setEndDate(null);
    setAssignedTo(null);
    setRepLevel(null);
    setSlot(null);
    setGender(null);
    setCategory(null);
    form.submit();
  };
  return (
    <>
      <span variant="primary" onClick={handleShow}>
        <Filter />
      </span>

      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Case Filter</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form className="order-filter" form={form} onFinish={onSubmit}>
          <Form.Item name="startDate">
              <DatePicker
                selected={startDate ? new Date(startDate) : null}
                onChange={(date) =>
                  setStartDate(date ? date.toISOString() : null)
                }
                dateFormat="yyyy-MM-dd"
                placeholderText="Start Date"
                isClearable
                className="form-control"
              />
            </Form.Item>
            <Form.Item name="endDate">
              <DatePicker
                selected={endDate ? new Date(endDate) : null}
                onChange={(date) =>
                  setEndDate(date ? date.toISOString() : null)
                }
                dateFormat="yyyy-MM-dd"
                placeholderText="End Date"
                isClearable
                maxDate={new Date()}
                minDate={startDate ? new Date(startDate) : null} 
                className="form-control"
              />
            </Form.Item>

            {currPathName.includes("/case-management/all-leads") && (
              <Form.Item name="gender">
                <Select
                  allowClear
                  style={{ width: "100%" }}
                  dropdownStyle={{ minWidth: "6rem" }}
                  options={genderOptions}
                  onChange={(e) => (e ? setGender(e) : setGender(null))}
                  placeholder="Gender"
                />
              </Form.Item>
            )}

            {(currPathName.includes("/case-management/all-cases") ||
              currPathName.includes("/case-management/new-leads")) && (
              <Form.Item name="caseStatus">
                <Select
                  allowClear
                  style={{ width: "100%" }}
                  dropdownStyle={{ minWidth: "6rem" }}
                  options={optionsCaseStatus}
                  onChange={(e) =>
                    e ? setCaseStatus(e) : setCaseStatus(undefined)
                  }
                  placeholder="Status"
                />
              </Form.Item>
            )}

            {(currPathName.includes("/case-management/all-cases") ||
              currPathName.includes("/case-management/all-leads") ||
              currPathName.includes("/assigned-leads")) && (
              <Form.Item name="feedback">
                <Select
                  style={{ width: "100%" }}
                  allowClear
                  dropdownStyle={{ minWidth: "12rem" }}
                  options={feedOptions}
                  onChange={(e) => (e ? setFeedback(e) : setFeedback(null))}
                  placeholder="Feedback"
                />
              </Form.Item>
            )}

            {userRole !== "sales" && (
              <Form.Item name="formStatus">
                <Select
                  style={{ width: "100%" }}
                  allowClear
                  dropdownStyle={{ minWidth: "6rem" }}
                  options={optionsFormStatus}
                  onChange={(e) => (e ? setFormStatus(e) : setFormStatus(null))}
                  placeholder="Form Status"
                />
              </Form.Item>
            )}

            <Form.Item name="assignedTo">
              <Select
                allowClear
                dropdownStyle={{ minWidth: 240 }}
                onChange={(e) => (e ? setAssignedTo(e) : setAssignedTo(null))}
                optionFilterProp="label"
                placeholder="Assigned To"
                showSearch
              >
                {!isEmpty(salesReps) &&
                  salesReps.userRole.map(({ user }) => (
                    <Option
                      label={user.first_name}
                      value={user.id}
                      key={user.id}
                    >
                      <Space align="center">
                        <span>{user.first_name}</span>
                        <Badge
                          count="Sales Rep"
                          style={{
                            backgroundColor: "#f1f1f1",
                            color: "#313131",
                          }}
                        />
                      </Space>
                    </Option>
                  ))}

                {!isEmpty(medReps) &&
                  medReps.userRole.map(({ user }) => (
                    <Option
                      label={user.first_name}
                      value={user.id}
                      key={user.id}
                    >
                      <Space align="center">
                        <span>{user.first_name}</span>
                        <Badge
                          count="Medical Rep"
                          style={{
                            backgroundColor: "#f1f1f1",
                            color: "#313131",
                          }}
                        />
                      </Space>
                    </Option>
                  ))}

                {!isEmpty(consultReps) &&
                  consultReps.userRole.map(({ user }) => (
                    <Option
                      label={user.first_name}
                      value={user.id}
                      key={user.id}
                    >
                      <Space align="center">
                        <span>{user.first_name}</span>
                        <Badge
                          count="Consult Rep"
                          style={{
                            backgroundColor: "#f1f1f1",
                            color: "#313131",
                          }}
                        />
                      </Space>
                    </Option>
                  ))}

                <Option label="N/A" value="NA">
                  <Space align="center">
                    <span>N/A</span>
                    <Badge
                      count="Not Assigned"
                      style={{ backgroundColor: "#f1f1f1", color: "#313131" }}
                    />
                  </Space>
                </Option>
              </Select>
            </Form.Item>

            {(currPathName.includes("/case-management/all-cases") ||
              currPathName.includes("/case-management/all-leads")) && (
              <Form.Item name="repLevel">
                <Select
                  allowClear
                  options={levelOptions}
                  onChange={(e) => (e ? setRepLevel(e) : setRepLevel(null))}
                  placeholder="Level"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            )}

            {(currPathName.includes("/case-management/all-cases") ||
              currPathName.includes("/case-management/all-leads") ||
              currPathName.includes("/case-management/new-leads")) && (
              <Form.Item name="category">
                <Select
                  allowClear
                  options={categoryOptions}
                  onChange={(e) => (e ? setCategory(e) : setCategory(null))}
                  placeholder="Form Type"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            )}
            {(currPathName.includes("/case-management/all-cases") ||
              currPathName.includes("/case-management/all-leads") ||
              currPathName.includes("/case-management/new-leads")) && (
              <Form.Item name="slot">
                <Select
                  allowClear
                  options={slotOptions}
                  onChange={(e) => (e ? setSlot(e) : setSlot(null))}
                  placeholder="Slot"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            )}
            <Form.Item
              style={{
                marginTop: 24,
                width: "97%",
              }}
            >
              <div
                className="flex gap-1"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ width: "80%" }}
                  disabled={isFormEmpty(form.getFieldsValue())}

                >
                  Apply
                </Button>
                <Button
                  htmlType="button"
                  onClick={handleClear}
                  style={{ width: "80%" }}
                >
                  Clear
                </Button>
              </div>
            </Form.Item>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default CaseFilter;
